// extracted by mini-css-extract-plugin
module.exports = {"ErrorPage":"ErrorPage_ErrorPage__3BslH","ErrorPageText":"ErrorPage_ErrorPageText__3--Hv","theme-light":"ErrorPage_theme-light__cVVPL","theme-dark":"ErrorPage_theme-dark__28yX6"};